import { createFileRoute } from "@tanstack/react-router";
import TripsPage from "@/components/trips/trips-page";

function BrokerCarrierTripsPage() {
  return (
    <TripsPage viewMode="carrier" brokerScope="partner" enableCarrierFilter />
  );
}

export const Route = createFileRoute("/_app/trips/carrier")({
  component: BrokerCarrierTripsPage,
});
